import axios from 'axios';
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import TicketEmailLayout from './TicketEmailLayout';

const TicketEmail = (details) => {
  const htmlEncodedString = ReactDOMServer.renderToStaticMarkup(
    <TicketEmailLayout details={details} />
  );
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlEncodedString, 'text/html');
  const htmlContent = doc.body.textContent;

  const formData = new FormData();
  formData.append('subject', `New ROTR Ticket From ${details.submittedBy}`);
  formData.append('htmlContent', htmlContent);

  return new Promise((resolve, reject) => {
    axios
      .post('/rotr/ticketEmail', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default TicketEmail;
